export const firebaseConfig = {
  apiKey: "AIzaSyBCpawUyZS9hliJ8ys9WVC84GNGuftfUFM",
  authDomain: "motion-platform-ui-dev.firebaseapp.com",
  projectId: "motion-platform-ui-dev",
  storageBucket: "motion-platform-ui-dev.firebasestorage.app",
  messagingSenderId: "363816964055",
  appId: "1:363816964055:web:fb8f37095e508e03df0592",
  measurementId: "G-1F0ZHERGW6"
};